// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2iIBW","label":"Radio_label__1hKlg","checkMark":"Radio_checkMark__i1zte","disabled":"Radio_disabled__2Y4BX"};